/* eslint-disable @typescript-eslint/no-unused-vars */
import { Card, CardBody, Col, Container, Input, Label, Row } from 'reactstrap'
import DataTable, { TableColumn } from "react-data-table-component";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
} from "reactstrap";
// import CollapseFilterData from './CollapseFilterData';
import { useEffect, useMemo, useState } from 'react';
import { SearchTableButton } from '../../../../utils/Constant';
import api from '../../../../utils/api';
import Swal from 'sweetalert2';
import { ClothListTableDataColumnType } from '../../../../Types/Application/Ecommerce/Ecommerce';
import { SVG } from '../../../../AbstractElements';
import ClothListFilterHeader from './ClothListFilterHeader';
import { ClothListTableOfferComponent, ClothListTableStatus } from '../../../../Types/Application/Ecommerce/ClothList';

const ClothListContainer = () => {
  const [filterText, setFilterText] = useState("");
  const [clothListTableDatas, setClothListTableDatas] = useState<ClothListTableDataColumnType[]>([]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editData, setEditData] = useState<any>(null);

  // Pagination-related states
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchCloths = async (page: number, size: number) => {
    try {
      setLoading(true);

      const response = await api.get(
        `/api/ClothMaster/GetAllClothMasterPagination?pageNumber=${page}&pageSize=${size}`
      );

      if (response.status === 200) {
        setClothListTableDatas(
          response.data.items.map((cloth: any) => ({
            clothId: cloth.clothId,
            clothQuantity: cloth.clothQuantity,
            clothSize: cloth.clothSize,
            clothPrice: cloth.clothPrice,
            isLocked: cloth.isLocked ? "Active" : "Inactive",
            gender: cloth.gender,
            securityCharges: cloth.securityCharges === null ? 0 : cloth.securityCharges,
          }))
        );

        // Set total record count from backend
        setTotalRows(response.data.totalCount);
      }
    } catch (error) {
      console.error("Failed to fetch cloth list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCloths(currentPage, pageSize);
  }, [currentPage, pageSize]);

  const handleDelete = async (id: number) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this cloth!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        confirmDelete(id);
      }
    });
  };

  const confirmDelete = async (id: number) => {
    try {
      await api.delete(`/api/ClothMaster/DeleteClothMaster?clothId=${id}`);
      Swal.fire('Deleted!', 'Cloth has been deleted.', 'success');

      // Refresh current page data
      await fetchCloths(currentPage, pageSize);
    } catch (error) {
      Swal.fire('Error!', 'Failed to delete the cloth.', 'error');
      console.error("Delete error:", error);
    }
  }

  // Edit

  const handleEdit = (row: any) => {
    setEditData(row);
    setEditModalOpen(true);
  };

  const handleEditChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  const handleEditSave = async () => {
    if (!editData || !editData.clothId || !editData.clothQuantity || !editData.clothPrice || !editData.securityCharges) {
      Swal.fire("Error!", "Please fill all fields before saving.", "error");
      return;
    }
    if (isNaN(Number(editData.clothQuantity)) || Number(editData.clothQuantity) <= 0) {
      Swal.fire("Error!", "Please enter a valid cloth quantity.", "error");
      return;
    }
    if (isNaN(Number(editData.clothPrice)) || Number(editData.clothPrice) <= 0) {
      Swal.fire("Error!", "Please enter a valid cloth price.", "error");
      return;
    }
    if (isNaN(Number(editData.securityCharges)) || Number(editData.securityCharges) < 0) {
      Swal.fire("Error!", "Please enter a valid security charge.", "error");
      return;
    }
    try {
      await api.put(`/api/ClothMaster/UpdateClothMaster`, {
        clothId: editData.clothId,
        clothQuantity: editData.clothQuantity,
        clothPrice: editData.clothPrice,
        securityCharges: editData.securityCharges,
      });

      // Refresh current page data
      await fetchCloths(currentPage, pageSize);

      setEditModalOpen(false);
      Swal.fire("Updated!", "Cloth has been updated.", "success");
    } catch (error) {
      Swal.fire("Error!", "Failed to update the cloth.", "error");
    }
  };


  const clothListTableDataColumn: TableColumn<ClothListTableDataColumnType>[] = [
    {
      name: "Id",
      cell: (row: any) => <ClothListTableOfferComponent title={row.clothId} />,
      sortable: true,
      grow: 2,
      minWidth: '100px',
    },
    {
      name: "Cloth Quantity",
      cell: (row) => <ClothListTableOfferComponent title={String(row.clothQuantity)} />,
      sortable: true,
      grow: 4,
      minWidth: '150px',
    },
    {
      name: "Cloth Size",
      cell: (row) => <ClothListTableOfferComponent title={row.clothSize} />,
      sortable: true,
      grow: 2,
      minWidth: '150px',
    },
    {
      name: "Gender",
      cell: (row) => <ClothListTableOfferComponent title={String(row.gender)} />,
      sortable: true,
      grow: 2,
      minWidth: '100px',
    },
    {
      name: "Cloth Price",
      cell: (row) => <ClothListTableOfferComponent title={String(row.clothPrice)} />,
      sortable: true,
      grow: 4,
      minWidth: '150px',
    },
    {
      name: "Security Charge",
      cell: (row) => <ClothListTableOfferComponent title={String(row.securityCharges)} />,
      sortable: true,
      grow: 4,
      minWidth: '150px',
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          <span
            onClick={() => handleEdit(row)}
            title="Edit"
            style={{ cursor: "pointer" }}
          >
            <SVG
              iconId="edit-content"
              style={{ fill: "blue", width: 18, height: 18 }}
            />
          </span>
          <span
            onClick={() => handleDelete(Number(row.clothId))}
            title="Delete"
            style={{ cursor: "pointer" }}
          >
            <SVG
              iconId="trash1"
              style={{ fill: "red", width: 18, height: 18 }}
            />
          </span>
        </div>
      ),
    },
  ];

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage: number, page: number) => {
    setPageSize(newPerPage);
    setCurrentPage(page);
  };

    const filteredItems = clothListTableDatas.filter((item: any) =>
    Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(filterText.toLowerCase()));

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div className="dataTables_filter d-flex align-items-center">
        <Label className="me-2">{SearchTableButton}:</Label>
        <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} type="search" value={filterText} />
      </div>
    );
  }, [filterText]);

  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <div className="list-product-header">
                <ClothListFilterHeader />
                {/* <CollapseFilterData /> */}
              </div>
              <div className="list-product">
                <div className="table-responsive">
                  <DataTable
                    data={filteredItems}
                    // data={clothListTableDatas}
                    columns={clothListTableDataColumn}
                    striped
                    highlightOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    paginationDefaultPage={currentPage}
                    paginationPerPage={pageSize}
                    progressPending={loading}
                    selectableRows
                    subHeader
                    subHeaderComponent={subHeaderComponentMemo}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal
        isOpen={editModalOpen}
        toggle={() => setEditModalOpen(!editModalOpen)}
      >
        <ModalHeader toggle={() => setEditModalOpen(!editModalOpen)}>
          Edit Cloth
        </ModalHeader>
        <ModalBody>
          {editData && (
            <>
              <FormGroup>
                <Label>Cloth Quantity</Label>
                <Input
                  name="clothQuantity"
                  value={editData.clothQuantity}
                  onChange={handleEditChange}
                  required={true}
                />
              </FormGroup>
              {/* <FormGroup>
                      <Label>Cloth Size</Label>
                      <select
                        name="clothSize"
                        className="form-control form-select"
                        value={editData.clothSize}
                        onChange={handleEditChange}
                        required={true}
                      >
                        <option value="1" selected={editData.clothSize === "1"}>Small(S)</option>
                        <option value="2" selected={editData.clothSize === "2"}>Medium(M)</option>
                        <option value="3" selected={editData.clothSize === "3"}>Large(L)</option>
                        <option value="4" selected={editData.clothSize === "4"}>Extra Large(XL)</option>
                        <option value="5" selected={editData.clothSize === "5"}>XXL</option>
                      </select>
                    </FormGroup> */}
              {/* <FormGroup>
                      <Label>Gender</Label>
                      <select
                        name="gender"
                        className="form-control form-select"
                        value={editData.gender}
                        onChange={handleEditChange}
                        required={true}
                      >
                        <option value="1" selected={editData.gender === "1"}>Male</option>
                        <option value="2" selected={editData.gender === "2"}>Female</option>
                        <option value="3" selected={editData.gender === "3"}>Baby Swim Suit</option>
                      </select>
                    </FormGroup> */}
              <FormGroup>
                <Label>Cloth Price</Label>
                <input
                  name="clothPrice"
                  type="text"
                  className="form-control"
                  placeholder="Enter price..."
                  value={editData.clothPrice}
                  onChange={handleEditChange}
                  required={true}
                />
              </FormGroup>
              <FormGroup>
                <Label>Security Charge</Label>
                <input
                  name="securityCharges"
                  type="text"
                  className="form-control"
                  placeholder="Enter security charge..."
                  value={editData.securityCharges}
                  onChange={handleEditChange}
                  required={true}
                />
              </FormGroup>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setEditModalOpen(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleEditSave}>
            Save
          </Button>
        </ModalFooter>
      </Modal>
    </Container>
  )
}

export default ClothListContainer